import * as angular from 'angular';
import * as _ from 'lodash';

import { ILoggerService } from '../../../services';
import { ComponentDefinition } from '../../../models';
import { DashboardThumbnailWidget } from '../../../widgets';

interface FormController extends angular.IFormController {
    newName: angular.INgModelController;
}

class DuplicateDashboardModalController implements angular.IComponentController {
    dashboard: DashboardThumbnailWidget;
    existing: { guid: string, name: string }[];
    existingDashboardName: string;
    formCtrl: FormController;
    groupsRename: { oldValue: string, newValue: string }[];
    isLoading: boolean;
    loadingMessage: string;
    newName: string;
    onDuplicated: (dashboard: any) => void;
    seriesRename: { oldValue: string, newValue: string }[];

    readonly duplicate: (value: { dashboardGuid: string, newName: string, seriesRename: any[], groupsRename: any[] }) => angular.IPromise<any>;

    private _modalName: string = 'duplicateDashboardModal';

    static $inject = [
        'loggerService',
        '$timeout'
    ];

    constructor(
        private _loggerService: ILoggerService,
        private _$timeout: angular.ITimeoutService
    ) {
    }

    $onInit() {
        this.seriesRename = [];
        this.groupsRename = [];
        $(`#${this._modalName}`)
            .on('hidden.bs.modal', () => {
                this.cleanForm();
            });
        $(`#${this._modalName}`)
            .on('shown.bs.modal', () => {
                this.newName = this.existingDashboardName;
                this._$timeout(() => {
                    this.validateName();
                });
            });
    }

    $onChanges(changesObj: angular.IOnChangesObject) {
        // if (changesObj && changesObj['existingDashboardName'] && changesObj['existingDashboardName'].currentValue) {
        //     const existingDashboardName = changesObj['existingDashboardName'].currentValue;
        //     this.newName = existingDashboardName;
        // }
    }

    update() {
        this.isLoading = true;
        const item = {
            dashboardGuid: this.dashboard.guid,
            newName: this.newName,
            seriesRename: this.seriesRename,
            groupsRename: this.groupsRename
        };

        this.duplicate(item)
            .then(data => {
                $(`#${this._modalName}`).modal('hide');
                if (this.onDuplicated) {
                    this.onDuplicated({ dashboard: _.find(data, d => d.name === this.newName) });
                }
                this._loggerService.logSuccess('Successfully duplicated dashboard');
                this.cleanForm();
            })
            .catch(e => this._loggerService.logError(e.message, true))
            .finally(() => this.isLoading = false);
    }

    validateName(): boolean {
        let isValid = true;
        if (this.newName) {
            const newValue = this.newName.toLowerCase();
            isValid = !_.some(this.existing, t => t.name.toLowerCase() === newValue);
            this.formCtrl.newName?.$setValidity('duplicate', isValid);
        }
        return isValid;
    }

    private cleanForm() {
        this.groupsRename = [];
        this.seriesRename = [];
        this.newName = null;
        this.formCtrl.$setPristine();
    }
}

export const wtDuplicateDashboardModal: ComponentDefinition = {
    componentId: 'wtDuplicateDashboardModal',
    controller: DuplicateDashboardModalController,
    template: require('./duplicateDashboardModal.component.html'),
    controllerAs: 'vm',
    bindings: {
        dashboard: '<',
        onDuplicated: '&?',
        existing: '<',
        duplicate: '&',
        existingDashboardName: '<'
    }
};
